import { Box, Flex } from '@/components/atoms/Grid'
import { Small } from '@/components/atoms/typography'
import { ProductRateData } from '@/network/graphql.g'
import { FC } from 'react'
import { Rating } from 'react-simple-star-rating'
import styled, { useTheme } from 'styled-components'
import { validFor } from '@/theme/validFor'

type DetailedStarRatingProps = {
  productRateData: ProductRateData
  star: number
  size?: number
}

const StarRatingDetailedRow: FC<DetailedStarRatingProps> = ({
  productRateData,
  star,
  size
}) => {
  const {
    rateCounts,
    oneStarCount,
    twoStarCount,
    threeStarCount,
    fourStarCount,
    fiveStarCount
  } = productRateData ?? {}
  const theme = useTheme()

  const starToCount = (star: number) => {
    switch (star) {
      case 1:
        return oneStarCount
      case 2:
        return twoStarCount
      case 3:
        return threeStarCount
      case 4:
        return fourStarCount
      case 5:
        return fiveStarCount
      default:
        return 0
    }
  }
  const calculatePercentage = (starToCount(star) / rateCounts) * 100

  return (
    <StyledFlex>
      <NumberOfStars m={0}>{star}</NumberOfStars>
      <Rating
        readonly
        initialValue={star}
        size={size || 14}
        fillColor={theme.colors.sizeTableDescription}
      />
      <RatingBar>
        <FilledBar percentage={calculatePercentage} />
      </RatingBar>
      <NumberOfRatings>({starToCount(star)})</NumberOfRatings>
    </StyledFlex>
  )
}

export default StarRatingDetailedRow

const StyledFlex = styled(Flex)`
  align-items: center;
  gap: 16px;
  ${validFor.mobile`
    gap: 8px;
`};
  ${validFor.tablet`
    gap: 8px;
`};
`

const NumberOfStars = styled(Small)`
  width: 8px;
  opacity: 0.6;
`

const RatingBar = styled(Box)`
  width: 180px;
  height: 4px;
  background-color: ${(props) => props.theme.colors.ratingProgressBarNeutral};
  ${validFor.mobile`
    width: 100%;
`};
  ${validFor.tablet`
    width: 100%;
`};
`

const FilledBar = styled(Box)`
  height: 100%;
  background-color: ${(props) => props.theme.colors.onBackground};
  width: ${(props) => props.percentage}%;
`

const NumberOfRatings = styled(Small)`
  opacity: 0.6;
  margin: 0;
  ${validFor.mobile`
    min-width: 48px;
`};
  ${validFor.tablet`
    min-width: 48px;
`};
`
